import swal from 'sweetalert';

class Alert {
  /**
   * Create new alert
   *
   * @param  {Object} options
   */
  create(options = {}) {
    if (options.html) {
      const wrap = document.createElement('div');
      wrap.innerHTML = options.html;
      options.content = wrap;

      delete options.html;
    }
    return swal({ ...options });
  }

  /**
   * Show error message
   *
   * @param  {Object} options
   */
  error(options = {}) {
    return this.create({
      icon: 'error',
      button: 'Close',
      ...options,
    });
  }

  /**
   * Show error message
   *
   * @param  {Object} options
   */
  warning(options = {}) {
    return this.create({
      icon: 'warning',
      button: 'Close',
      ...options,
    });
  }

  /**
   * Show success message
   *
   * @param  {Object} options
   */
  success(options = {}) {
    return this.create({
      icon: 'success',
      button: 'Close',
      ...options,
    });
  }

  /**
   * Confirm warning
   * @param  {Object} options
   */
  confirm(options = {}) {
    return this.create({
      icon: 'warning',
      dangerMode: true,
      buttons: ['No', 'Yes'],
      ...options,
    });
  }
}

export default new Alert();
